export default "__VITE_ASSET__ea834f46__"